<template>
    <div>
        <div class="card card-default">
            <div class="card-body">
                <button
                    v-if="impersonator"
                    class="btn btn-outline-danger"
                    @click="confirmCancellation"
                    data-test="cancel-button"
                >
                    Cancel Subscription
                </button>
                <p v-else>
                    If you would like to <span class="text-danger"><b>cancel your subscription</b></span> please contact
                    <a href="mailto:support@voxiechat.com">support@voxiechat.com</a>.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { VxSwal } from '@voxie/frontend-components';
import axios from '~/services/axios';
import { throwSwalRequestError } from '~/utils/request';

export default {
    props: {
        impersonator: {
            type: Boolean,
            default: false
        },

        teamId: {
            type: Number
        }
    },

    created() {
        this.getTeam();

        Bus.$on('updateTeam', () => {
            this.getTeam();
        });

    },
    methods: {
        confirmCancellation() {
            VxSwal.confirmation('Cancel Subscription', 'Are you sure you want to cancel your subscription?', 'danger', () => axios.delete(this.urlForCancellation)
                            .then(() => Bus.$emit('updateTeam')).catch(throwSwalRequestError))
        },
        getTeam() {
            axios.get(`/settings/teams/json/${this.teamId}`)
                .then(response => {
                    this.team = response.data;
                });
        },

    },
    computed: {
        urlForCancellation() {
            return `/settings/teams/${this.teamId}/subscription`;
        }
    }
}
</script>
